/**
 * NewsletterOptin Component
 */

import React, { ChangeEvent, FC, useRef } from "react";
import { withTheme } from "styled-components";
import {
  NewsletterOptinMessageIcons,
  NewsletterOptinProps,
} from "./newsletterOptin.types";
import Skeleton from "../Skeleton/skeleton";
import MessageIcon from "./MessageIcon/messageIcon";
import NewsletterLogo from "./NewsletterLogo/newsletterLogo";

import {
  Form,
  Fieldset,
  Input,
  InputWrapper,
  Message,
  Submit,
  Title,
} from "./newsletterOptin.style";
import { ButtonTypes } from "../Button/button.types";

const NewsletterOptin: FC<NewsletterOptinProps> = ({
  buttonHandlers = {},
  children,
  disableInputs = false,
  email = "",
  emailInputRef: emailInputRefProp,
  inputHandlers = {},
  isLoading,
  logoDark,
  logoLight,
  messageIcon = NewsletterOptinMessageIcons.DEFAULT,
  newsletterIds,
  placeholder = "Enter your email",
  showInputs = true,
  submitText = "Sign Up",
  theme = {},
  title,
}: NewsletterOptinProps) => {
  const { dark } = theme;
  const { onChange: inputOnChange } = inputHandlers;

  const emailInputRef: any =
    emailInputRefProp || useRef<HTMLInputElement>(null);

  const handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void = (e) => {
    if (/[<>]+/.test(e.target.value)) {
      return;
    }
    if (inputOnChange) {
      inputOnChange(e);
    }
  };

  const inputAdditionalProps = {
    maxLength: 320,
  };

  const NewsletterOptinContent = isLoading ? (
    <Fieldset dark={dark}>
      <Skeleton height={50} count={1} />
      <Skeleton height={10} count={2} />
      <Skeleton height={30} count={1} />
    </Fieldset>
  ) : (
    <Fieldset dark={dark}>
      <NewsletterLogo
        logoLight={logoLight}
        logoDark={logoDark}
        darkTheme={dark}
      />
      <Title>{title}</Title>
      <Message hasIcon={messageIcon !== NewsletterOptinMessageIcons.DEFAULT}>
        <MessageIcon icon={messageIcon} />
        {children}
      </Message>
      {showInputs && (
        <InputWrapper>
          <Input
            additionalProps={
              disableInputs
                ? { ...inputAdditionalProps, ...{ disabled: true } }
                : inputAdditionalProps
            }
            handlers={{
              ...inputHandlers,
              onChange: handleInputChange,
            }}
            inputType={"email"}
            placeHolder={placeholder}
            refElement={emailInputRef}
            value={email}
          />
          <Submit
            disabled={disableInputs}
            handlers={buttonHandlers}
            label={submitText}
            type={ButtonTypes.SUBMIT}
          />
        </InputWrapper>
      )}
    </Fieldset>
  );

  return (
    <Form dark={dark}>
      <input
        type="hidden"
        name="newsletterOptinNewsletterIds"
        value={newsletterIds.join(",")}
      />
      {NewsletterOptinContent}
    </Form>
  );
};

export default withTheme(NewsletterOptin);
